import React, { useState, useEffect } from 'react'
import {
  SMALL_DESKTOP,
  LARGE_DESKTOP,
  MEDIUM_DESKTOP,
  MAX_QUESTION_HEIGHT,
  MIN_QUESTION_HEIGHT,
  MIN_CANVAS_HEIGHT
} from '../constants'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'
import PropTypes from 'prop-types'

function MatchTableComponent(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onValueChange,
    onAttemptChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    handleSucAndFailFeedback
  } = props

  const {
    ControlID,
    QuestionText,
    QuestionType,
    Description,
    Answers,
    Score,
    Background,
    AnswerColorFill,
    QuestionColorFill,
    AnswerFontSize,
    QuestionColor,
    QuestionFontSize,
    Opacity,
    AnswerFillColor,
    QuestionFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    QuestionHeight,
    Priority,
    SequenceHint,
    Url
  } = mcData
  const canvasAreaHeight = 100 - QuestionHeight

  const [selectedAnswerArray, setSelectedAnswerArray] = useState([])
  const [currentScore, setCurrentScore] = useState(0)

  useEffect(() => {
    window.addEventListener(
      'message',
      function receiveMessage(event) {
        // console.log(event);

        if (event.data.result === undefined) {
          return // Only handle messages with result
        }

        console.log(' just scored ' + event.data.result.score.raw)
        onAttemptChange(1)
        setCurrentScore(event.data.result.score.raw)
      },
      false
    )
  }, [])

  useEffect(() => {
    if (currentScore > 0) {
      onValueChange(ControlID, [], currentScore, Score, '', false)
    }
  }, [currentScore])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, selectedAnswerArray)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    //Filter selectedAnswer for validation
    if (defaultValue && defaultValue.CtlScore) {
      if (defaultValue.CtlScore === Score) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundColor: Background !== '' ? Background : '#dc8c82',
        justifyContent: 'center',
        borderRadius: !isEmbeded ? '10px' : 0
      }}
      onClick={() => {
        if (explanationClick && isEmbeded) {
          // explanationValidation();
        }
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: Opacity,
          padding: !isEmbeded ? '15px' : 0
        }}
      >
        {QuestionText &&
          QuestionText !== '' &&
          (QuestionType && QuestionType === 'text' ? (
            <div
              className='scrollBox card-shadow'
              style={{
                minHeight: MIN_QUESTION_HEIGHT,
                maxHeight: MAX_QUESTION_HEIGHT,
                height: QuestionHeight + '%',
                justifyContent: 'center',
                // alignSelf: "center",
                backgroundColor: QuestionFillColor,
                borderRadius: '10px',
                padding: '1%'
              }}
            >
              <p
                style={{
                  width: 'fit-content',
                  justifyContent: 'center',
                  color: QuestionColorFill,
                  fontSize:
                    QuestionFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : QuestionFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  whiteSpace: 'pre-wrap',
                  margin: 0
                }}
              >
                {QuestionText}
              </p>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                margin: '2%',
                minHeight: MIN_QUESTION_HEIGHT,
                maxHeight: MAX_QUESTION_HEIGHT,
                height: QuestionHeight + '%',
                alignItems: 'center',
                zIndex: 6,
                justifyContent: 'center'
              }}
            >
              <div
                className='card-shadow'
                style={{
                  width: 'fit-content',
                  justifyContent: 'center',
                  backgroundColor:
                    QuestionType === 'inktotext' ? QuestionFillColor : 'white',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  height: '100%',
                  maxHeight: '100px',
                  minWidth: '10%',
                  padding: '1%',
                  fontSize:
                    QuestionFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : QuestionFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP
                }}
              >
                {QuestionType === 'inktotext' ? (
                  <span
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <InlineMath>{QuestionText}</InlineMath>
                  </span>
                ) : (
                  <img
                    src={QuestionText}
                    style={{
                      width: '70px',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                    alt='image'
                  />
                )}
              </div>
              {Description !== '' && (
                <div
                  className='scrollBox card-shadow'
                  style={{
                    width: '100%',
                    height: '100%',
                    marginLeft: '1%',
                    marginRight: '1%',
                    display: 'flex',
                    backgroundColor: QuestionFillColor,
                    borderRadius: '10px',
                    padding: '1%'
                  }}
                >
                  <p
                    style={{
                      width: 'fit-content',
                      justifyContent: 'center',
                      alignItems: 'flex-end',
                      color: QuestionColorFill,
                      fontSize:
                        QuestionFontSize === 'SMALL'
                          ? SMALL_DESKTOP
                          : QuestionFontSize === 'LARGE'
                          ? LARGE_DESKTOP
                          : MEDIUM_DESKTOP,
                      margin: 0,
                      whiteSpace: 'pre-wrap'
                    }}
                  >
                    {Description}
                  </p>
                </div>
              )}
            </div>
          ))}

        <div
          style={{
            width: isEmbeded ? '100%' : '80%',
            height: isEmbeded
              ? '100%'
              : QuestionText !== ''
              ? canvasAreaHeight + '%'
              : '100%',
            minHeight: MIN_CANVAS_HEIGHT,
            justifyContent: 'center',
            borderRadius: isEmbeded ? 0 : '20px',
            backgroundColor: '#ffffff33',
            flexDirection: 'column',
            alignSelf: 'center',
            marginTop: isEmbeded ? 0 : '1%'
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex'
            }}
          >
            <iframe
              style={{ width: '100%', height: '100%', display: 'flex' }}
              src={Url}
              title='h5p'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

MatchTableComponent.propTypes = {
  mcData: PropTypes.object.isRequired,
  isPractice: PropTypes.bool.isRequired,
  completed: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  onValueChange: PropTypes.func.isRequired,
  onAttemptChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.object,
  explanationClick: PropTypes.bool.isRequired,
  onExplanationVisible: PropTypes.func.isRequired,
  isVerifyMode: PropTypes.bool,
  handleSuccessChange: PropTypes.func,
  timerEnd: PropTypes.bool,
  isEmbeded: PropTypes.bool,
  onPriorityChange: PropTypes.func,
  followTheFlow: PropTypes.bool,
  currentPriority: PropTypes.number,
  sequenceMessage: PropTypes.func
}

export default MatchTableComponent
